module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-dashboard"
  }, [_c('app-navigation', {
    attrs: {
      "hideAuxNavOnDesktop": true,
      "currentSpace": _vm.$t('web.dashboard.nav_space')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-dashboard-branding"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.platformImages.dashboard_branding_desktop + ', ' +
        _vm.platformImages.dashboard_branding_desktop_2x + ' 2x',
      "media": "(min-width: 960px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.platformImages.dashboard_branding_tablet + ', ' +
        _vm.platformImages.dashboard_branding_tablet_2x + ' 2x',
      "media": "(min-width: 720px)"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.platformImages.dashboard_branding_mobile,
      "srcset": _vm.platformImages.dashboard_branding_mobile + ', ' +
        _vm.platformImages.dashboard_branding_mobile_2x + ' 2x',
      "alt": _vm.$t('web.dashboard.alt_text_banner_image')
    }
  })])]), _vm._v(" "), _c('main', {
    staticClass: "o-dashboard__main"
  }, [_vm._l((_vm.dashboardLayout), function(card) {
    return [(typeof _vm.cards[card.id] !== 'undefined') ? _c('card-' + _vm.cards[card.id].type, {
      key: card.id,
      tag: "component",
      attrs: {
        "card": _vm.cards[card.id],
        "loaded": _vm.cardsLoaded.includes(card.id)
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-303d4958"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 523
// module chunks = 1